import { TableCard } from 'app/components'
import { ExamesListHeader } from './components/header/ExamesListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ExamesTable } from './table/ExamesTable'

const ExamesList = () => {
  return (
    <TableCard>
      <ExamesListHeader />
      <ExamesTable />
    </TableCard>
  )
}

export const ExamesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <ExamesList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
